/**
 * Monta a rota da questão, apontando para uma etapa específica quando houver.
 *
 * A listagem expande um Estudo de Caso em uma linha por etapa `step_multiple`,
 * cada uma com o próprio código: abrir uma dessas linhas leva direto à etapa
 * dela, pelo mesmo `?step={question_steps.id}` que o QR Code do PDF usa — ver
 * parseStepIdFromSearch.
 *
 * Sem etapa, a rota fica inalterada e a questão abre na primeira.
 */
export const buildQuestionRoute = (
  questionId: number | string,
  questionStepId?: number | null,
): string => {
  const base = `/new-questions/${questionId}`;

  return questionStepId ? `${base}?step=${questionStepId}` : base;
};
